import { DeleteFilled } from "@ant-design/icons"
import { Col, Row } from "antd"
import { LandingReview } from "../../../../domain/entities/LandingReview"
import DataTable from "../../../components/DataTable/DataTable"
import { colors } from "../../../assets/styles/appStyles"
import DataTableRowsSkeleton from "../../../styledComponents/LoadingSkeletons/DataTableRowsSkeleton"
import TABLE_COLUMNS from "../const/MARKETPLACE_LANDING_REVIEWS_TABLE_COLUMNS"

interface Props {
	reviews: LandingReview[]
	isLoading?: boolean
	onChange?: (id: number, value: LandingReview) => void
	onDelete?: (id: number) => void
}

const MarketplaceLandingReviewsFormSection = ({ reviews, isLoading, onChange, onDelete }: Props) => {
	const handleSave = (record: any) => {
		onChange && onChange(record.id, record)
	}

	return (
		<Row gutter={[24, 0]}>
			<Col md={24} xl={24} xs={24}>
				<DataTable
					loading={isLoading}
					renderCustomLoadingComponent={() => <DataTableRowsSkeleton />}
					editableCells={{ handleSave }}
					columns={TABLE_COLUMNS()}
					dataSource={reviews.map(review => ({
						key: review.id,
						id: review.id,
						name: review.reviewerName,
						content: (
							<p
								style={{
									color: "black",
									overflow: "hidden",
									textOverflow: "ellipsis",
									whiteSpace: "nowrap",
									maxWidth: "50rem"
								}}
							>
								{review.contentEs}
							</p>
						),
						weight: review.weight,
						actions: (
							<div key={review.id}>
								<DeleteFilled
									style={{ fontSize: "1.2rem", color: colors.error }}
									onClick={() => onDelete && onDelete(review.id)}
								/>
							</div>
						)
					}))}
				/>
			</Col>
		</Row>
	)
}

export default MarketplaceLandingReviewsFormSection
